export const initialSchema = {
  fields: {},
  errors: {},
  validators: {}
};
